import { CREATE_ORDER } from "../../constants/ActionTypes";

export const createOrderData = (action) => {
  return {
    type: CREATE_ORDER,
    payload: action,
  };
};
